module.exports = __webpack_public_path__ + "img/debian.68a0c2f.svg";